import React, { useState, useRef, useEffect } from 'react'
import Select, { components } from 'react-select';
import H2 from '../Headings/H2'
import H4 from '../Headings/H4'
import IconComponent from '../icons';
import BaseButton from "../BaseButton";
import { PushGADataLayer, pureKeys, sortedOptions } from '../../utils/helpers';
import { handleMarkerAutoSelect, resetMapPin } from "./leaflet-init";
import Tabs from '../Tabs';
import H3 from '../Headings/H3';

export default function NetworkLocalOffice({ localOfficeInfo, selectedStationInfo, mapData }) {

    const selectCountryRef = useRef();
    const [optionsRegion, setOptionsRegion] = useState([]);
    const [optionsCountry, setOptionsCountry] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [isSubmit, setIsSubmit] = useState(false);
    const [filteredStations, setFilteredStations] = useState([]);
    const [activeTab, setActiveTab] = useState('');
    const [selectedTab, setSelectedTab] = useState('');
    useEffect(() => {
        let localOffices = [];
        mapData?.data?.forEach((region) => {
            if (!localOffices.find((localOffice) => localOffice?.label === region.region)) {
                const regionVal = {
                    "value": region.region,
                    "label": region.region,
                    "countries": [
                        {
                            "value": region.country,
                            "label": region.country,
                        }
                    ]
                };
                localOffices.push(regionVal)
            } else {
                const countryVal = {
                    "value": region.country,
                    "label": region.country
                }
                if (!localOffices.find((localOffice) => localOffice?.label === region.region).countries.find((country) => country?.label === region.country)) {
                    localOffices.find((localOffice) => localOffice?.label === region.region).countries.push(countryVal);
                }
            }
        });
        // sort regions alphabetically
        localOffices = sortedOptions(localOffices);
        // sort countries for each region alphabetically
        localOffices.forEach((region) => region.countries = sortedOptions(region.countries));
        setOptionsRegion(localOffices);
    }, [mapData])

    useEffect(()=>{
        const selectedStation = filteredStations && filteredStations.find((tab, index) => ((tab?.title + index) === activeTab))?.stations[0];
        resetMapPin()
        if(selectedStation)handleMarkerAutoSelect(selectedStation,false, true);
        const element = document.getElementById("tabsList");
        const item = document.querySelector('.is--active-tab');
        if(item && element){
            if(item.offsetLeft >  element.offsetWidth){
                element.scrollTo({ left: item.offsetLeft-100, behavior: 'smooth' });
            }
            else{
                element.scrollTo({ left: 0, behavior: 'smooth' });
            }
        }
       
        
    },[activeTab, filteredStations])

    const customStyles = {
        valueContainer: (provided, state) => ({
            ...provided,
            height: '50px !important',
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: '#666666 !important'
        }),
        singleValue : (provided, state) => ({
            ...provided,
            color: '#666666 !important'
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '50px !important'
        })
    }


    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <IconComponent icon='chevron-slim' className={`chevron-slim text-ek-red relative rotate-90 mx-2`} />
            </components.DropdownIndicator>
        );
    };

    const changeRegion = (event) => {
        selectCountryRef.current.getValue().length && selectCountryRef.current.clearValue();
        setSelectedRegion(event.label);
        setIsSubmit(false);
        setOptionsCountry(optionsRegion.find((regions) => regions.label === event.label).countries);
        setSelectedCountry(null)
        setFilteredStations([])
    }

    const changeCountry = (event) => event?.label && setSelectedCountry(event.label);

    const handleSubmit = () => {
        setIsSubmit(true);
        if (selectedRegion && selectedCountry) {
            PushGADataLayer('Contact Us', 'Find Local Office', selectedRegion + ':' + selectedCountry);
            setFilteredStations(mapData.data.filter((region) => region.region === selectedRegion).filter((region) => region.country === selectedCountry).map((region) => region = { ...region, title: region.stations[0].place }));
            setSelectedTab("")
        }
    }

    useEffect(()=>{
        if(selectedStationInfo){
            setSelectedRegion(localOfficeInfo?.region);
            setOptionsCountry(optionsRegion.find((regions) => regions.label === localOfficeInfo?.region).countries);
            setSelectedCountry(localOfficeInfo?.country);
            setFilteredStations(mapData.data.filter((region) => region.region === localOfficeInfo?.region).filter((region) => region.country === localOfficeInfo?.country).map((region) => region = { ...region, title: region.stations[0].place }));
        
        }
    },[selectedStationInfo, optionsRegion, mapData])
    
   
    useEffect(()=>{
            const stationName = localOfficeInfo?.station?.place;
            const index = filteredStations.findIndex((tab) => (tab?.title === stationName));
            if (index !== -1) { setActiveTab(localOfficeInfo?.station?.place + index);setSelectedTab(localOfficeInfo?.station?.place + index)}
    },[filteredStations])

    return (
        <div className="grid lg:grid-cols-12 -mt-24 z-20 relative group-[.modal-open]/body:z-30">
            <div className={`lg:col-start-1 lg:col-end-13 xl:col-start-2 xl:col-end-12 bg-white border border-ek-grey-300 px-5 py-[30px] lg:p-10 rounded-lg lg:w-[90.52%] xl:w-[95.52%] mx-auto`}>
                {mapData?.localOffice?.subtitle && <H2 className='!leading-[41.6px]'>{mapData?.localOffice.subtitle}</H2>}
                <div className={`py-4 lg:py-6 lg:gap-5 grid lg:grid-cols-12`}>
                    <div className="mb-4 lg:mb-0 lg:col-start-1 lg:col-span-5">
                        <Select
                            defaultValue={selectedRegion}
                            value={optionsRegion.find(option => option.value === selectedRegion)}
                            onChange={(e) => changeRegion(e)}
                            options={optionsRegion}
                            isSearchable={false}
                            isDisabled={optionsRegion.length === 0}
                            placeholder={'Select region'}
                            components={{ DropdownIndicator }}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            classNames={{
                                control: () => `${isSubmit && selectedRegion === null ? "!border-ek-red-200" : "!border-ek-grey-300"}`,
                                dropdownIndicator: (state) => state.selectProps.menuIsOpen ? '!rotate-180' : "-!rotate-180",
                            }}
                            styles={customStyles}
                        />
                        {isSubmit && selectedRegion === null && <div className="text-ek-red-200 text-xs font-light leading-[18px] tracking-[0.05px]">{'Select region'}</div>}
                    </div>
                    <div className="mb-4 lg:mb-0 lg:col-span-5">
                        <Select
                            defaultValue={selectedCountry}
                            value={optionsCountry.find(option => option.value === selectedCountry)}
                            ref={selectCountryRef}
                            onChange={(e) => changeCountry(e)}
                            options={optionsCountry}
                            isSearchable={false}
                            isDisabled={optionsCountry.length === 0}
                            placeholder={'Select country'}
                            components={{ DropdownIndicator }}
                            className="react-select-container"
                            classNamePrefix="react-select"
                            classNames={{
                                control: () => `${isSubmit && selectedCountry === null ? "!border-ek-red-200" : "!border-ek-grey-300"}`,
                                dropdownIndicator: (state) => state.selectProps.menuIsOpen ? '!rotate-180' : "-!rotate-180",
                            }}
                            styles={customStyles}
                        />
                        {isSubmit && selectedCountry === null && <div className="text-ek-red-200 text-xs font-light leading-[18px] tracking-[0.05px]">{'Select country'}</div>}
                    </div>
                    <div className="mb-4 lg:mb-0 lg:col-span-1" >
                        <BaseButton  type="primary" btnClick={handleSubmit} btnType="submit" title={'SEARCH'} size="large" className={`lg:text-base !px-5 pt-3.5 pb-3 lg:h-[50px] font-bold w-full lg:w-auto lg:mr-6`}></BaseButton>
                    </div>
                </div>
                {
                    filteredStations && filteredStations.length>0 &&
                    <>
                    <H3 className='py-6'>Emirates Skycargo Office</H3>
                    <Tabs data={{ tabList: filteredStations }} activeTab={activeTab} setActiveTab={setActiveTab} isCenter={false} isScroll={true} selectedTab={selectedTab}>
                        <div className='pt-4'>
                            {
                                filteredStations.map((tab, index) => ((tab?.title + index) === activeTab) && <H4>{tab.stations[0].airport}</H4>)
                            }
                            {  filteredStations.map((tab, index) => ((tab?.title + index) === activeTab) && tab.stations[0].details.tabs?.[0]?.col1Items && tab.stations[0].details.tabs?.[0]?.col1Items.map((item, i) => (
                                        <div className="mt-4 lg:mt-6" key={pureKeys((item?.subtitle || '') + i + '_leftcol')}>
                                            {
                                                item?.subtitle && <h6 className="font-bold text-base lg:text-lg text-black">{item?.subtitle}</h6>
                                            }
                                            {item?.desc && (
                                                <div className="text-ek-grey-500 text-sm tracking-[0.56px] mt-0.5 lg:mt-3" dangerouslySetInnerHTML={{ __html: item?.desc }}>
                                                </div>
                                            )}
                                        </div>
                                    )
                                ))}
                        </div>
                    </Tabs>
                    </>
                }
            </div>
        </div>
    )
}
